import type { I18n } from '../types';

export enum LoadingErrorType {
  Network = 'NETWORK',
  Unknown = 'UNKOWN',
}

export interface ScreenError {
  type: LoadingErrorType;
  name: string;
}

export interface ErrorScreenProps {
  error: ScreenError;
  translations: I18n;
  biLogger: {
    report: (reportProps: any) => Promise<any>;
  };
}
